import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ValidateCodeAPI from '../helpers/ValidateCodeAPI';
import MechanismSection from './MechanismSection';
import WinnersSection from './WinnersSection';
import RulesAndContact from './RulesAndContact';
import StartQuiz from './StartQuiz';
import QuizAnalytics from './QuizAnalytics';

const AdminRoute: React.FC = () => {
  const { adminCode } = useParams<{ adminCode: string }>();
  const navigate = useNavigate();
  const [isValidating, setIsValidating] = useState(true);
  const [isValidCode, setIsValidCode] = useState(false);

  useEffect(() => {
    const validateAdminCode = async () => {
      if (!adminCode) {
        navigate('/');
        return;
      }

      setIsValidating(true);
      
      // Validacija admin koda preko backenda
      const isValid = await ValidateCodeAPI(adminCode);
      
      if (isValid) {
        console.log('✅ Admin kod je validan:', adminCode);
        setIsValidCode(true);
      } else {
        console.log('❌ Admin kod nije validan:', adminCode);
        // Redirektuj na običan home (bez StartQuiz sekcije)
        navigate('/');
      }
      
      setIsValidating(false);
    };

    validateAdminCode();
  }, [adminCode, navigate]);

  // Prikaži loader dok se validira kod
  if (isValidating) {
    return (
      <div className="admin-validation-loader">
        <h2>Validacija pristupa...</h2>
        <p>Molimo vas sačekajte.</p>
      </div>
    );
  }

  // Ako kod nije validan, ne renderuj ništa (redirect će se desiti)
  if (!isValidCode) {
    return null;
  }

  // Ako je kod validan, prikaži home sa StartQuiz sekcijom
  return (
    <>
      <section id="mehanizam">
        <MechanismSection />
      </section>
      <section id="start-quiz" className="start-quiz-section">
        <StartQuiz />
      </section>
      <section id="analitika">
        <QuizAnalytics />
      </section>
      <section id="lista-dobitnika">
        <WinnersSection />
      </section>
      <section id="pravila-kontakt">
        <RulesAndContact />
      </section>
    </>
  );
};

export default AdminRoute;

